/**
 * 商务平板路由
 * */
export default [
  {
    path: "/flatIndex",
    name: "flatIndex",
    meta: {
      title: '首页'
    },
    component: () => import("@/views/FlatSystem/index")
  },{
    path: '/flatSystemChannelList',
    name: 'flatSystemChannelList',
    component: () => import('@/views/FlatSystem/deviceManage/channelList'),
    meta: {
      title: '渠道管理'
    }
  },{
    path: '/flatSystemMachineList',
    name: 'flatSystemMachineList',
    component: () => import('@/views/FlatSystem/deviceManage/machineList'),
    meta: {
      title: '机型管理'
    }
  },{
    path: '/flatSystemDeviceList',
    name: 'flatSystemDeviceList',
    component: () => import('@/views/FlatSystem/deviceManage/deviceList'),
    meta: {
      title: '设备管理'
    }
  },{
    path: '/flatSystemOtaManger',
    name: 'flatSystemOtaManger',
    component: () => import('@/views/FlatSystem/apply/otaManger'),
    meta: {
      title: 'OTA管理'
    }
  },{
    path: '/flatSystemOtaDownloadLogs',
    name: 'flatSystemOtaDownloadLogs',
    component: () => import('@/views/FlatSystem/apply/otaDownloadLogs'),
    meta: {
      title: 'OTA升级记录'
    }
  },{
    path: '/flatSystemImeiErrorLogList',
    name: 'flatSystemImeiErrorLogList',
    component: () => import('@/views/FlatSystem/deviceManage/imeiErrorLogList'),
    meta: {
      title: '设备日志'
    }
  },{
    path: '/flatSystemAddModelPage',
    name: 'flatSystemAddModelPage',
    meta: {
      title: '新增机型'
    },
    component: () => import('@/views/FlatSystem/deviceManage/addModelPage')
  },{
    path: '/flatSystemEditModelPage',
    name: 'flatSystemEditModelPage',
    meta: {
      title: '编辑机型'
    },
    component: () => import('@/views/FlatSystem/deviceManage/editModelPage')
  },{
    path: '/flatDeviceMonthRegister',
    name: 'flatDeviceMonthRegister',
    meta: {
      title: '设备统计'
    },
    component: () => import('@/views/FlatSystem/bi/deviceMonthRegister')
  },{
    path: '/flatSystemOtaUpdateAddPage',
    name: 'flatSystemOtaUpdateAddPage',
    meta: {
      title: 'OTA新增'
    },
    component: () => import('@/views/FlatSystem/apply/otaUpdateAddPage')
  },{
    path: '/flatSystemOtaUpdateEditPage',
    name: 'flatSystemOtaUpdateEditPage',
    meta: {
      title: 'OTA编辑'
    },
    component: () => import('@/views/FlatSystem/apply/otaUpdateEditPage')
  },{
    path: '/flatSystemDeviceQualityAssessment',
    name: 'flatSystemDeviceQualityAssessment',
    meta: {
      title: '智能检测'
    },
    component: () => import('@/views/FlatSystem/deviceManage/deviceQualityAssessment')
  },{
    path: '/flatSystemDeviceLogView',
    name: 'flatSystemDeviceLogView',
    meta: {
      title: '设备日志'
    },
    component: () => import('@/views/FlatSystem/baby/deviceLogView'),
  },{
    path: '/flatSystemSearchAppUse',
    name: 'flatSystemSearchAppUse',
    component: () => import('@/views/FlatSystem/bi/searchAppUse'),
    meta: {
      title: '使用分析'
    },
  },{
    path: '/flatSystemChannelAppPage',
    name: 'flatSystemChannelAppPage',
    component: () => import('@/views/FlatSystem/deviceManage/ChannelAppPage'),
    meta: {
      title: '渠道APP关系管理'
    },
  },{
    path: '/flatSystemOtaBiHome',
    name: 'flatSystemOtaBiHome',
    component: () => import('@/views/FlatSystem/bi/otaBiHome'),
    meta: {
      title: 'OTA升级统计'
    },
  },{
    path: '/flatSystemCheckModel',
    name: 'flatSystemCheckModel',
    component: () => import('@/views/FlatSystem/deviceManage/checkModel'),
    meta: {
      title: '查看机型'
    }
  },
  {
    path: '/flatKiDozApp',
    name: 'flatKiDozApp',
    component: () => import("@/views/FlatSystem/bi/KiDozApp"),
    meta: {
      title: 'kiDozApp'
    }
  },
  {
    path: '/otaRequestLog',
    name: 'otaRequestLog',
    component: () => import("@/views/FlatSystem/bi/otaRequestLog"),
    meta: {
      title: 'ota请求日志'
    }
  }, {
    path: '/flatVirtualSnBatchList',
    name: 'flatVirtualSnBatchList',
    component: () => import("@/views/FlatSystem/deviceManage/virtualSnBatchList"),
    meta: {
      title: '授权批次'
    }
  }, {
    path: '/flatVirtualSnLicenseList',
    name: 'flatVirtualSnLicenseList',
    component: () => import("@/views/FlatSystem/deviceManage/virtualSnLicenseList"),
    meta: {
      title: '授权许可'
    }
  }, {
    path: '/flatApkManager',
    name: 'flatApkManager',
    component: () => import("@/views/FlatSystem/apply/apkManager"),
    meta: {
      title: 'APK管理'
    }
  },{
    path: '/flatApkUpdateAddPage',
    name: 'flatApkUpdateAddPage',
    meta: {
      title: 'Apk新增'
    },
    component: () => import('@/views/FlatSystem/apply/apkUpdateAddPage')
  },{
    path: '/flatApkUpdateEditPage',
    name: 'flatApkUpdateEditPage',
    meta: {
      title: 'Apk编辑'
    },
    component: () => import('@/views/FlatSystem/apply/apkUpdateEditPage')
  },{
    path: '/OtaUpgrade',
    name: 'OtaUpgrade',
    meta: {
      title: 'OTA升级统计'
    },
    component: () => import('@/views/publicView/bi/OtaUpgrade')
  },{
    path: '/ApkUpgrade',
    name: 'ApkUpgrade',
    meta: {
      title: 'APK升级统计'
    },
    component: () => import('@/views/publicView/bi/ApkUpgrade')
  }
  ,{
    path: '/flatSystemDeviceNew',
    name: 'flatSystemDeviceNew',
    meta: {
      title: '设备管理(新)'
    },
    component: () => import('@/views/FlatSystem/deviceManage/deviceNew')
  }
]



// WEBPACK FOOTER //
// ./src/router/flatRouter.js